import { render, staticRenderFns } from "./DetailCreditCard.vue?vue&type=template&id=5368df9e"
import script from "./DetailCreditCard.vue?vue&type=script&lang=js"
export * from "./DetailCreditCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports